import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingService } from '../services';

@Pipe({ name: 'cssSafe' })

/**
 * CssSafePipe wil do its best to ensure that a string is converted to a form
 * suitable for use in CSS class names.
 *
 * @see FormattingService
 */
export class CssSafePipe implements PipeTransform {
  private formattingService = inject(FormattingService);

  constructor() {

  }

  transform(value: string): string {
    return this.formattingService.formatDisplayTextAsCssClass(value) ?? '';
  }
}
